import { useGetMarketStatus } from "~/v2/api/hooks";
import { MarketStatusPillPresentation } from "./MarketStatusPill.pres";
import { phaseToPill } from "./marketStatusPill.utils";

export const MarketStatusPill = () => {
  const { marketStatus } = useGetMarketStatus();
  const pill = phaseToPill(marketStatus?.phase);

  if (!pill) {
    return null;
  }

  return <MarketStatusPillPresentation {...pill} />;
};
